import { type ReactNode, type FC, type MouseEventHandler } from 'react'
import cx from 'classnames'
import { twMerge } from 'tailwind-merge'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { type DefaultProps } from '../common'

export interface ListRowProps extends DefaultProps {
  onClick?: MouseEventHandler<HTMLButtonElement>
  hasBorder?: boolean
  title: string
  description?: string
  descriptionClassName?: string
  icon?: ReactNode
}

export const ListRow: FC<ListRowProps> = ({
  onClick,
  className,
  descriptionClassName,
  id,
  testId,
  ariaLabel,
  hasBorder,
  title,
  description,
  icon,
}) => {
  // Component base class names. Can be overridden by className property.
  const baseClass = cx('w-full py-sm', {
    'border-b border-light': hasBorder,
  })

  // Final class names
  const finalClasses = twMerge(baseClass, className)

  const baseClassDescription = cx('flex justify-start text-left typo-primary-sm text-text-meta pr-xl mt-3xs')

  // Final class names
  const finalClassesDescription = twMerge(baseClassDescription, descriptionClassName)

  return (
    <button
      className={finalClasses}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
      onClick={onClick}
      data-test-id={testId}
      type="button"
    >
      <div className="flex justify-between typo-primary-base-regular text-text-body">
        <span>{title}</span>
        {/* Icon */}
        {icon ? icon : <ChevronDownIcon className="size-6 -rotate-90" />}
      </div>
      {/* Description */}
      {description ? <p className={finalClassesDescription}>{description}</p> : null}
    </button>
  )
}
